import {
  IProductLookUpRequest,
  IProductLookUpRepositoryResponse,
} from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetProductLookUpUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(params?: IProductLookUpRequest): Promise<IProductLookUpRepositoryResponse> {
    return this.lookupRepository.getProducts(params);
  }
}
